/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// LOVELE V7 — atualiza a referência da tonalidade conforme a variante escolhida.
document.addEventListener('change', function (event) {
  var input = event.target;
  if (!input || !input.matches('.color-swatch__radio[data-lovele-shade-detail]')) return;

  var option = input.closest('.product-form__option');
  if (!option) return;

  var description = option.querySelector('[data-lovele-shade-description]');
  if (description) {
    description.textContent = input.getAttribute('data-lovele-shade-detail') || '';
  }
});

/* LOVELE V13 — fallback do menu mobile.
   O Warehouse possui o controlador nativo em theme.js. Este fallback só age
   quando o clique não altera o estado, evitando dupla execução. */
(function () {
  function setMenuState(toggle, menu, open) {
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    menu.setAttribute('aria-hidden', open ? 'false' : 'true');

    if (open) {
      var header = document.querySelector('.header');
      var headerBottom = header ? Math.max(0, header.getBoundingClientRect().bottom) : 64;
      var viewportHeight = window.visualViewport ? window.visualViewport.height : window.innerHeight;
      var availableHeight = Math.max(260, viewportHeight - headerBottom);
      menu.style.setProperty('--lovele-mobile-menu-top', headerBottom + 'px');
      menu.style.setProperty('--lovele-mobile-menu-height', availableHeight + 'px');
      document.body.classList.add('no-mobile-scroll');
    } else {
      menu.style.removeProperty('--lovele-mobile-menu-top');
      menu.style.removeProperty('--lovele-mobile-menu-height');
      menu.style.maxHeight = '';
      document.body.classList.remove('no-mobile-scroll');
      menu.querySelectorAll('.mobile-menu__panel.is-open').forEach(function (panel) {
        panel.classList.remove('is-open');
      });
      menu.querySelectorAll('[data-action="open-panel"][aria-expanded="true"]').forEach(function (button) {
        button.setAttribute('aria-expanded', 'false');
      });
    }
  }

  function installLoveleMobileMenuFallback() {
    document.querySelectorAll('.header__mobile-nav-toggle[data-action="toggle-menu"][aria-controls]').forEach(function (toggle) {
      if (toggle.dataset.loveleMenuFallback === 'true') return;
      toggle.dataset.loveleMenuFallback = 'true';

      toggle.addEventListener('click', function () {
        var menuId = toggle.getAttribute('aria-controls');
        var menu = menuId ? document.getElementById(menuId) : null;
        if (!menu) return;

        var before = toggle.getAttribute('aria-expanded') === 'true';
        window.setTimeout(function () {
          var after = toggle.getAttribute('aria-expanded') === 'true';
          if (after === before) {
            setMenuState(toggle, menu, !before);
          }
        }, 0);
      });
    });

    document.addEventListener('click', function (event) {
      var opener = event.target.closest && event.target.closest('.mobile-menu [data-action="open-panel"]');
      if (opener) {
        var wasExpanded = opener.getAttribute('aria-expanded') === 'true';
        window.setTimeout(function () {
          if ((opener.getAttribute('aria-expanded') === 'true') === wasExpanded) {
            var panel = document.getElementById(opener.getAttribute('aria-controls'));
            if (panel) {
              opener.setAttribute('aria-expanded', 'true');
              panel.classList.add('is-open');
            }
          }
        }, 0);
        return;
      }

      var closer = event.target.closest && event.target.closest('.mobile-menu [data-action="close-panel"]');
      if (closer) {
        var panelToClose = closer.closest('.mobile-menu__panel.is-open');
        if (!panelToClose) return;
        window.setTimeout(function () {
          if (panelToClose.classList.contains('is-open')) {
            panelToClose.classList.remove('is-open');
            var controller = document.querySelector('[aria-controls="' + panelToClose.id + '"]');
            if (controller) controller.setAttribute('aria-expanded', 'false');
          }
        }, 0);
      }
    });

    window.addEventListener('resize', function () {
      var menu = document.getElementById('mobile-menu');
      var toggle = document.querySelector('.header__mobile-nav-toggle[aria-controls="mobile-menu"]');
      if (menu && toggle && toggle.getAttribute('aria-expanded') === 'true') {
        var header = document.querySelector('.header');
        var headerBottom = header ? header.getBoundingClientRect().bottom : 64;
        menu.style.maxHeight = Math.max(240, window.innerHeight - headerBottom) + 'px';
      }
    });
  }

  if (document.readyState === 'loading') {
    function refreshOpenLoveleMenu() {
    document.querySelectorAll('.header__mobile-nav-toggle[aria-expanded="true"][aria-controls]').forEach(function (toggle) {
      var menu = document.getElementById(toggle.getAttribute('aria-controls'));
      if (menu) setMenuState(toggle, menu, true);
    });
  }

  window.addEventListener('resize', refreshOpenLoveleMenu);
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', refreshOpenLoveleMenu);
  }

  document.addEventListener('DOMContentLoaded', installLoveleMobileMenuFallback);
  } else {
    installLoveleMobileMenuFallback();
  }

  document.addEventListener('shopify:section:load', installLoveleMobileMenuFallback);
})();

/* LOVELE V15 — scroll lock robusto do menu mobile no Safari/iOS.
   Observa o estado real do drawer, funcionando tanto com o controlador nativo
   do Warehouse quanto com o fallback da LOVELE. */
(function () {
  var locked = false;
  var savedScrollY = 0;
  var savedBodyStyles = null;

  function getViewportHeight() {
    return window.visualViewport ? window.visualViewport.height : window.innerHeight;
  }

  function refreshDrawerGeometry(menu) {
    if (!menu || menu.getAttribute('aria-hidden') !== 'false') return;

    var header = document.querySelector('.header');
    var headerBottom = header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
    var viewportHeight = getViewportHeight();
    var availableHeight = Math.max(260, viewportHeight - headerBottom);

    menu.style.setProperty('--lovele-mobile-menu-top', headerBottom + 'px');
    menu.style.setProperty('--lovele-mobile-menu-height', availableHeight + 'px');
  }

  function lockBackground(menu) {
    if (locked) {
      refreshDrawerGeometry(menu);
      return;
    }

    savedScrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
    savedBodyStyles = {
      position: document.body.style.position,
      top: document.body.style.top,
      left: document.body.style.left,
      right: document.body.style.right,
      width: document.body.style.width,
      overflow: document.body.style.overflow,
      touchAction: document.body.style.touchAction
    };

    /* Mede antes de fixar o body para preservar a posição visual do header. */
    refreshDrawerGeometry(menu);

    document.documentElement.classList.add('lovele-mobile-menu-open');
    document.body.classList.add('lovele-mobile-menu-open');

    document.body.style.position = 'fixed';
    document.body.style.top = '-' + savedScrollY + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
    document.body.style.overflow = 'hidden';
    document.body.style.touchAction = 'none';

    locked = true;
  }

  function unlockBackground() {
    if (!locked) return;

    document.documentElement.classList.remove('lovele-mobile-menu-open');
    document.body.classList.remove('lovele-mobile-menu-open');

    if (savedBodyStyles) {
      document.body.style.position = savedBodyStyles.position;
      document.body.style.top = savedBodyStyles.top;
      document.body.style.left = savedBodyStyles.left;
      document.body.style.right = savedBodyStyles.right;
      document.body.style.width = savedBodyStyles.width;
      document.body.style.overflow = savedBodyStyles.overflow;
      document.body.style.touchAction = savedBodyStyles.touchAction;
    }

    var restoreY = savedScrollY;
    savedBodyStyles = null;
    locked = false;

    /* Restaura exatamente o ponto em que a cliente estava antes de abrir o menu. */
    window.requestAnimationFrame(function () {
      window.scrollTo(0, restoreY);
    });
  }

  function syncMenuState(menu) {
    if (!menu) return;
    if (menu.getAttribute('aria-hidden') === 'false') {
      lockBackground(menu);
    } else {
      unlockBackground();
    }
  }

  function installLoveleScrollLock() {
    var menu = document.getElementById('mobile-menu');
    if (!menu || menu.dataset.loveleScrollLockInstalled === 'true') return;

    menu.dataset.loveleScrollLockInstalled = 'true';

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'aria-hidden') {
          syncMenuState(menu);
        }
      });
    });

    observer.observe(menu, { attributes: true, attributeFilter: ['aria-hidden'] });
    syncMenuState(menu);

    function refreshIfOpen() {
      if (menu.getAttribute('aria-hidden') === 'false') {
        refreshDrawerGeometry(menu);
      }
    }

    window.addEventListener('resize', refreshIfOpen, { passive: true });
    window.addEventListener('orientationchange', refreshIfOpen, { passive: true });

    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', refreshIfOpen, { passive: true });
      window.visualViewport.addEventListener('scroll', refreshIfOpen, { passive: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', installLoveleScrollLock);
  } else {
    installLoveleScrollLock();
  }

  document.addEventListener('shopify:section:load', installLoveleScrollLock);
})();
